/* person-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./person-card.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import { IconButton, LinkButton } from '@atlaskit/button/new';
import EmailIcon from '@atlaskit/icon/core/email';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { SainAction, useAnalytics, useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { messages } from '../../messages';
import { onKnowledgeCardLinkClick } from '../analytics';
import { onEmailCopy } from '../util';
var styles = {
  wrapper: "_8vu41mok _1dbz130s",
  card: "_2rko1mok _bfhkhp5a _16qst7xp _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsb1ijo",
  clickableCard: "_2rko1mok _bfhkhp5a _16qst7xp _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsb1ijo _80omtlke",
  tooltip: "_11c8dcr7 _syaz15cr",
  tooltipContainer: "_2rko12b0 _1rjcv77o _18zr12x7 _bfhk1aqn _4cvr1h6o _1pby9y44 _kqswstnw _1ltvv77o _94n5c7mi _p12fp3fh"
};
var userNameStyles = null;
var userSubheadingStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var tooltipOptions = {
  position: 'bottom'
};
export var PersonCard = function PersonCard(_ref) {
  var name = _ref.name,
    profilePicUrl = _ref.profilePicUrl,
    jobTitle = _ref.jobTitle,
    profileUrl = _ref.profileUrl,
    email = _ref.email,
    accountId = _ref.accountId,
    _ref$isHoverState = _ref.isHoverState,
    isHoverState = _ref$isHoverState === void 0 ? true : _ref$isHoverState,
    onCardClick = _ref.onCardClick;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    tipState = _useState2[0],
    setTipState = _useState2[1];
  var _navigateToTeamsApp = navigateToTeamsApp({
      type: 'USER',
      payload: {
        userId: accountId
      },
      cloudId: commonAttributes.cloudId
    }),
    profileHref = _navigateToTeamsApp.href,
    profileOnNavigate = _navigateToTeamsApp.onNavigate;
  var Wrapper = !isHoverState && !!onCardClick ? function (props) {
    return /*#__PURE__*/React.createElement(Box, {
      xcss: styles.wrapper,
      onClick: function onClick() {
        fireSAINUsageEvent({
          metCriteria: SainAction.PERSON_SELECTED
        });
        fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          location: 'person-card-click'
        })));
        onCardClick();
      }
    }, props.children);
  } : Fragment;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    alignItems: "center",
    gap: "space.200",
    xcss: !isHoverState && !!onCardClick ? styles.clickableCard : styles.card
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Avatar, {
    src: profilePicUrl,
    size: "xlarge"
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    alignItems: "center",
    gap: "space.100"
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_11c8nbxd _1reo15vq _18m915vq _syazi7uo _y3gn1h6o _1nmz9jpi _1e0ccj1k _sudp1e54 _1yyjkb7n"])
  }, name), jobTitle && /*#__PURE__*/React.createElement("div", {
    className: ax(["_11c82smr _1reo15vq _18m915vq _syazazsu _y3gn1h6o _1nmz9jpi _1e0ccj1k _sudp1e54 _1yyjkb7n"])
  }, jobTitle)), /*#__PURE__*/React.createElement(Flex, {
    gap: "space.050"
  }, email && /*#__PURE__*/React.createElement(IconButton, {
    icon: function icon(props) {
      return /*#__PURE__*/React.createElement(EmailIcon, _extends({}, props, {
        color: "var(--ds-icon, #292A2E)"
      }));
    },
    onClick: function onClick() {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'person-card-copy-email'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.COPY_CLICKED
      });
      onEmailCopy(email);
    },
    label: formatMessage(messages.knowledge_cards_copy_email_address),
    onMouseEnter: function onMouseEnter() {
      return setTipState(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setTipState(false);
    },
    isTooltipDisabled: isHoverState,
    tooltip: tooltipOptions
  }), profileUrl && /*#__PURE__*/React.createElement(LinkButton, {
    href: fg('platform-adopt-teams-nav-config') ? profileHref : profileUrl,
    target: "_blank",
    onClick: function onClick(e) {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'person-card-view-profile'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.VIEW_PROFILE_CLICKED
      });
      if (fg('platform-adopt-teams-nav-config')) {
        profileOnNavigate(e);
      }
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_who_questions_view_profile)), isHoverState && tipState && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.tooltipContainer
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.tooltip
  }, formatMessage(messages.knowledge_cards_copy_email_address))))));
};